module.exports = __webpack_public_path__ + "static/media/2@2x.f48b78d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity50/2@2x.png
// module id = 361
// module chunks = 0